var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoMealsMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "no_meals"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2006_1792",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2006_1792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "no_meals_2",
    d: "M31.6665 27.6806L28.8471 24.8611V23.3611H27.3471L24.0277 20.0417V10.9722C24.0277 10.0463 24.2059 9.12729 24.5624 8.21523C24.9189 7.3032 25.3842 6.48608 25.9582 5.76385C26.5323 5.04163 27.1851 4.45599 27.9165 4.00694C28.648 3.55785 29.3888 3.33331 30.1388 3.33331C30.5647 3.33331 30.9258 3.49072 31.2221 3.80552C31.5184 4.12036 31.6665 4.49536 31.6665 4.93052V27.6806ZM35.5277 37.4583C35.2499 37.7361 34.9189 37.875 34.5346 37.875C34.1504 37.875 33.8193 37.7361 33.5415 37.4583L31.2221 35.1805H31.6665V35.2916C31.6665 35.6898 31.5346 36.0208 31.2707 36.2847C31.0068 36.5486 30.6758 36.6805 30.2777 36.6805C29.8795 36.6805 29.5485 36.5486 29.2846 36.2847C29.0207 36.0208 28.8888 35.6898 28.8888 35.2916V32.8472L2.111 6.0694C1.83322 5.79162 1.69434 5.45366 1.69434 5.05552C1.69434 4.65738 1.83322 4.31942 2.111 4.04165C2.38878 3.76387 2.71979 3.62498 3.10404 3.62498C3.48829 3.62498 3.81931 3.76387 4.09709 4.04165L35.5277 35.5139C35.8055 35.7916 35.9443 36.1157 35.9443 36.4861C35.9443 36.8565 35.8055 37.1805 35.5277 37.4583ZM19.7221 15.6806L16.9443 12.9584V4.72219C16.9443 4.32405 17.0763 3.99304 17.3402 3.72915C17.6041 3.46526 17.9351 3.33331 18.3332 3.33331C18.7313 3.33331 19.0624 3.46526 19.3263 3.72915C19.5901 3.99304 19.7221 4.32405 19.7221 4.72219V15.6806ZM14.5832 10.5972L11.8054 7.81944V4.72219C11.8054 4.32405 11.9374 3.99304 12.2013 3.72915C12.4651 3.46526 12.7962 3.33331 13.1943 3.33331C13.5925 3.33331 13.9235 3.46526 14.1874 3.72915C14.4513 3.99304 14.5832 4.32405 14.5832 4.72219V10.5972ZM9.44429 5.45831L7.31929 3.33331C7.92115 3.33331 8.42579 3.53702 8.83321 3.94444C9.2406 4.35183 9.44429 4.85645 9.44429 5.45831ZM13.1943 36.6666C12.7962 36.6666 12.4651 36.5347 12.2013 36.2708C11.9374 36.0069 11.8054 35.6759 11.8054 35.2778V21.3611C10.3703 21.0278 9.15497 20.2824 8.15959 19.125C7.16422 17.9676 6.66654 16.5926 6.66654 15V6.65277L9.44429 9.43052V15H11.8054V11.7916L14.5832 14.5694V15H15.0138L18.6249 18.6111C18.1619 19.3055 17.5809 19.8912 16.8818 20.368C16.1827 20.8449 15.4165 21.1759 14.5832 21.3611V35.2778C14.5832 35.6759 14.4513 36.0069 14.1874 36.2708C13.9235 36.5347 13.5925 36.6666 13.1943 36.6666Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMealsMobile);
export default __webpack_public_path__ + "static/media/no-meals-mobile.89f2a8db9be34d4de82f6fb97d307c10.svg";
export { ForwardRef as ReactComponent };